import { create } from 'zustand';

const useTextAreaFocus = create((set) => ({
  focusRequest: false,
  focus: () => set({ focusRequest: true }),
  blur: () => set({ focusRequest: false }),
}));

export default useTextAreaFocus;
